import { cloudChiprApi } from "../../../../services/cloudchipr.api";

export const getTaskActivitiesEndpointSelector = (taskId: string) =>
  cloudChiprApi.endpoints.getUsersMeOrganisationsCurrentTasksByTaskIdActivities.select(
    { taskId },
  );
